import axios, { AxiosResponse } from 'axios'
import { ArquivoDto } from '../../../apps/atendimento/core/_models'
import { InformacaoAssinatura } from './_models'

const API_URL = process.env.REACT_APP_API_URL

/**
 * Download de documento assinado
 * @param token Código localizador
 * @param codigo Código de desbloqueio
 * @returns ArquivoDto
 */
export const downloadDocumentoAssinado = (token: string, codigo: string): Promise<ArquivoDto> => {
  return axios
    .get(`${API_URL}/public/assinatura/download/${token}?code=${codigo}`)
    .then((resp: AxiosResponse<ArquivoDto>) => resp.data)
}

/**
 * Obter informações do documento assinado
 * @param token Código localizador
 * @param codigo Código de desbloqueio
 * @returns InformacaoAssinatura[]
 */
export const informacoesDocumentoAssinado = (
  token: string,
  codigo?: string
): Promise<InformacaoAssinatura[]> => {
  return axios
    .get(`${API_URL}/public/assinatura/informacoes/${token}${codigo ? `?code=${codigo}` : ''}`)
    .then((resp: AxiosResponse<InformacaoAssinatura[]>) => resp.data)
}
